import type { EntryPoint } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type PopupContent from './popup-content';

export const loadingPopupEntryPoint: EntryPoint<typeof PopupContent, {}> = createEntryPoint({
	root: JSResourceForInteraction<typeof PopupContent>(
		// Intentionally unresolved so the documentation keeps showing the loading state.
		() => new Promise<typeof PopupContent>(() => undefined),
		{ moduleId: 'constellation-loading-popup-entry-point' },
	),
	getPreloadProps: () => ({}),
});
